
interface Props {
    label: string;
    value: string;
    error?: string
    rootClassName?: string
}
const Detailltem = (props: Props) => {
    const { rootClassName = "" } = props;
    return (
        <div className={rootClassName}>
            <p className="text-[12px] text-[#475467] mb-[4px]">{props.label}</p>
            <p className="text-[13px] font-[500] m-0">{props.value || "-"}</p>
            {props.error && !props.value ? (
                <p className="text-[12px] text-[#D92D20] m-0">{props.error}</p>
            ) : (
                <></>
            )}

        </div>
    )
}

export default Detailltem